import React, {  useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT  } from "constants/variables";
import Box from '@mui/material/Box'; 
import Container from '@mui/material/Container';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import "css/generalSettings.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp"; 
import TableSortingPurchaseStoreAddresses from 'pages/purchases/editOrNewPurchaseDelivery/SortingTablesPurchaseAddress'; 
import PropTypes from 'prop-types'; 

const initialStateStoreAddresses = [{
  "id":"",
  "indexrowaddress":0,
  "street":"",
  "roadtype_id":0,
  "roadtype_namees":"",
  "roadtype_nameen":"",
  "country_id":1,
  "country_namees":"",
  "country_nameen":"",
  "province_id":30,
  "province_name":"",
  "postalcode_id":6911,
  "postalcode_code":"",
  "postalcode_name":"",
  "postalcode_postalcodename":"",
  "community_id":6,
  "community_namees":"",
  "community_nameen":""

}];

const PurchaseSearchStoresAddresses = ({ showModalSearchStoresAddress, setShowModalSearchStoresAddress,selectStores,setFormPurchaseDelivery,titleTable,store_id,priority}) => {
  const {t,i18n} = useTranslation(['listDataForms']);
  const state = useSelector((state) => state);
  const {token} = state.loginUser
  const [dataStoreAddresses, setDataStoreAddresses] = useState(initialStateStoreAddresses);
  const [numTotRegStoreAddresses,setNumTotRegStoreAddresses]= useState(0); 
 
  const dispatch = useDispatch(); 
   
  const keyPress = useCallback(
    (e) => {
     
      if (e.key === 'Escape' && showModalSearchStoresAddress) {
        setDataStoreAddresses(initialStateStoreAddresses);
        setNumTotRegStoreAddresses(0);
        setShowModalSearchStoresAddress(false);
      }
    },
    [ setDataStoreAddresses,
      setNumTotRegStoreAddresses,
      showModalSearchStoresAddress,
      setShowModalSearchStoresAddress
    ]
  );

  const handleCloseDataEditStoreAdresses = () => {
    setDataStoreAddresses(initialStateStoreAddresses);
    setNumTotRegStoreAddresses(0);
    setShowModalSearchStoresAddress(false);
	};

  const toggleDrawerSearchFormStoreAddresses  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataEditStoreAdresses();
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);
  
       
  useEffect(() => {
    let isMounted = true;

    const fetchnumTotRegStoreAdresses = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT, `purchasedelivery/getinformationtablestoreaddress/`, token,store_id);
        if (getData.err) {
          setDataStoreAddresses(initialStateStoreAddresses);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegStoreAddresses(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
  
    const fetchDataStoreAdresses = async () => {
      try {
        const getData = await helpHttp().get8(ENDPOINT,`purchasedelivery/getaddressesstoresbystoreid`,token,store_id,priority);
        if (getData.err || getData.message === "Load failed") {
          setDataStoreAddresses(initialStateStoreAddresses);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataStoreAddresses(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    
    if (showModalSearchStoresAddress){
      fetchnumTotRegStoreAdresses(); 
      fetchDataStoreAdresses();
    }
    return () => { isMounted = false };
  }, [t,i18n,token,dispatch,showModalSearchStoresAddress,store_id,priority]);
 
  return(
    <>
      {showModalSearchStoresAddress && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerSearchFormStoreAddresses(false)}
            onOpen={toggleDrawerSearchFormStoreAddresses(true)}>
            <Container >
              <Box sx={{ bgcolor: '#ffffff',height:'1300px', width: '1100px'}}>
                <div id="myDIV">
                  <h1 className="h1NewStyle mb-2"> {t('Text_FORM_Stores_Address_Search')}</h1>
                  <div>
                    <button type="button" className="buttonCreate" onClick={handleCloseDataEditStoreAdresses}>{t('Button_Exit')}</button><> </>
                  </div> 
                </div>  
                <br/>
                
                <div className="card shadow mb-4">    
                  <div className="card-body">
                    <TableSortingPurchaseStoreAddresses
                      dataStoreAddresses={dataStoreAddresses}
                      numTotRegStoreAddresses={numTotRegStoreAddresses}
                      titleTable={titleTable}
                      selectStores={selectStores}
                      setFormPurchaseDelivery={setFormPurchaseDelivery}
                      handleCloseDataEditStoreAdresses={handleCloseDataEditStoreAdresses}
                    />
                  </div>             
                </div>
                {/* End Content Row */}                
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

PurchaseSearchStoresAddresses.propTypes = {
  showModalSearchStoresAddress : PropTypes.bool.isRequired,
  setShowModalSearchStoresAddress : PropTypes.func.isRequired,
  selectStores : PropTypes.string.isRequired,
  setFormPurchaseDelivery : PropTypes.func.isRequired,
  titleTable : PropTypes.string.isRequired,
  priority: PropTypes.number.isRequired
};

export default PurchaseSearchStoresAddresses;
